<template>
  <div class="main">
    <div class="text">
      <div class="line"></div>
      <span class="desc">最近看过的H5案例</span>
    </div>
    <img src="../assets/page02_person.png" alt="人物" srcset="" class="person">
    <span v-on:click="go">
      <img src="../assets/page02_btn.png" alt="button" class="btn-img">
    </span>
    <rotate-it />
  </div>
</template>

<script>
import Rotate from './Rotate'
export default {
  name: 'Pg2',
  components: {
    'rotate-it': Rotate
  },
  methods: {
    go () {
      this.$router.push('/')
    }
  }

}
</script>

<style type="text/css" scoped>
.main {
  background-color: #f8f8f8;
  width: 100vw;
  height: 100vh;
  position: relative;
}

.text {
  color: #949494;
  padding-top: 5.13vw;
  text-align: center;
  font-size: 3.1vw;
  position: relative;
  z-index: 1;
}

.line::before {
  content: '';
  position: absolute;
  z-index: -1;
  pointer-events: none;
  background-color: #ddd;
  height: 1px;
  left: 0;
  right: 0;
  bottom: 8.5px;
}

.person {
  position: absolute;
  left: 17.6vw;
  top: 20vh;
  width: 61.3vw;
}
.sample {
  position: absolute;
  left: 0;
  top: 2.4vw;
  width: 35.2vw;
}

.btn-img {
  position: absolute;
  bottom: 14.667vh;
  /* display: block; */
  left: 12.8vw;
  width: 74.9vw;
}

.desc {
  background-color: #f8f8f8
}

@media only screen and (-webkit-min-device-pixel-ratio: 2) {
  .line::before {
    content: '';
    position: absolute;
    z-index: -1;
    pointer-events: none;
    background-color: #ddd;
    height: 1px;
    left: 0;
    right: 0;
    bottom: 8.5px;
  }
  -webkit-transform: scaleY(0.5);
  -webkit-transform-origin: 50% 0%;
}

</style>



// WEBPACK FOOTER //
// src/components/Pg2.vue